(() => {
  const blockedHashes = new Set(["#briar-key-benefits"]);

  const cleanBlockedHash = () => {
    if (!blockedHashes.has(window.location.hash)) return;
    const cleanUrl = window.location.pathname + window.location.search;
    window.history.replaceState(null, document.title, cleanUrl);
  };

  const scrollToTarget = event => {
    const trigger = event.target.closest("[data-briar-scroll-target]");
    if (!trigger) return;

    const targetId = trigger.getAttribute("data-briar-scroll-target");
    const target = targetId ? document.getElementById(targetId) : null;
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
    cleanBlockedHash();
  };

  cleanBlockedHash();
  window.addEventListener("hashchange", cleanBlockedHash);
  document.addEventListener("click", scrollToTarget);
})();
